import { Routes } from '@angular/router';
import { MyForestComponent } from './my-forest.component';
import { MyForestUserInfoComponent } from './my-forest-user-info/my-forest-user-info.component';

export const routes: Routes = [
  { path: '', component: MyForestComponent },
  {
    path: 'user/:userPublicId',
    data: { title: 'my-forest.my-forest', breadcrumb: 'replacer=username' },
    component: MyForestUserInfoComponent
  }
];
